import { render, staticRenderFns } from "./SortCourseMaterialListItem.vue?vue&type=template&id=57117ab4&scoped=true"
import script from "./SortCourseMaterialListItem.vue?vue&type=script&lang=js"
export * from "./SortCourseMaterialListItem.vue?vue&type=script&lang=js"
import style0 from "./SortCourseMaterialListItem.vue?vue&type=style&index=0&id=57117ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57117ab4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
